// T-178 — Modale "Validità registri HACCP" (consultabile offline).
// Rende il documento unico (packages/shared complianceDoc) e linka alla versione
// web/PDF. Il testo NON va duplicato qui: arriva da @trackeat/shared.

import {
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonContent,
  IonIcon,
} from '@ionic/react';
import { closeOutline, globeOutline, downloadOutline } from 'ionicons/icons';
import {
  COMPLIANCE_DOC_TITLE,
  COMPLIANCE_DOC_BODY_HTML,
} from '@trackeat/shared';

const WEB_URL = 'https://trackeat.eu/validita-registri';

// Stile del corpo documento (classi cd-* usate sia qui sia nella pagina landing).
const DOC_CSS = `
.cd-body { color: #0f172a; line-height: 1.6; font-size: 15px; }
.cd-body h2 { font-size: 17px; font-weight: 800; margin: 22px 0 8px; color: #0f172a; }
.cd-body p { margin: 8px 0; }
.cd-body ul { margin: 8px 0; padding-left: 20px; }
.cd-body li { margin: 6px 0; }
.cd-body a { color: #0066cc; }
.cd-updated { font-size: 12px; color: #64748b; font-weight: 600; }
.cd-callout { background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 12px; padding: 12px 14px; margin: 14px 0; font-size: 14px; }
.cd-note { background: #fffbeb; border: 1px solid #fde68a; border-radius: 12px; padding: 12px 14px; margin: 14px 0; font-size: 14px; }
.cd-sign { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px; padding: 14px; margin: 16px 0; font-size: 14px; }
.cd-sign-line { margin-top: 14px; color: #475569; }
`;

export function ComplianceDocModal(props: {
  isOpen: boolean;
  onClose: () => void;
}): JSX.Element {
  return (
    <IonModal isOpen={props.isOpen} onDidDismiss={props.onClose}>
      <IonHeader>
        <IonToolbar>
          <IonTitle style={{ fontSize: 16 }}>Validità registri HACCP</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={props.onClose} aria-label="Chiudi">
              <IonIcon slot="icon-only" icon={closeOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <style>{DOC_CSS}</style>
        <h1 style={{ fontSize: 20, fontWeight: 800, lineHeight: 1.3, margin: '4px 0 10px' }}>
          {COMPLIANCE_DOC_TITLE}
        </h1>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', margin: '0 0 16px' }}>
          <IonButton size="small" fill="outline" onClick={() => window.open(WEB_URL, '_blank', 'noopener')}>
            <IonIcon slot="start" icon={globeOutline} />
            Versione web
          </IonButton>
          <IonButton size="small" fill="outline" onClick={() => window.open(WEB_URL, '_blank', 'noopener')}>
            <IonIcon slot="start" icon={downloadOutline} />
            Scarica PDF
          </IonButton>
        </div>
        <div className="cd-body" dangerouslySetInnerHTML={{ __html: COMPLIANCE_DOC_BODY_HTML }} />
      </IonContent>
    </IonModal>
  );
}
